export default __webpack_public_path__ + "static/media/lost-modal.d9d3217a.png";